// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'information-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='round'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path fill='#fff' d='M8.208 7.848H9.36v4.536' />
          <path d='M8.208 12.384h2.232' />
          <circle cx='9' cy='5' r='.25' />
        </mask>
      </defs>
      <circle
        cx='9.25'
        cy='9.25'
        r='8'
        fill='currentColor'
        stroke='currentColor'
        mask={`url(#${maskId})`}
      />
    </>
  );
};

export const viewBox = '0 0 18 18';
